import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import Field from '../Field.js';
import FieldGroup, { FieldChoiceGroup, FieldHint, FieldRow, FieldSet } from '../FieldGroup.js';
import countries from '@/utils/countries.json';
import Tooltip from '../Tooltip.js';
import SolidCircleInfoIcon from '@/components/icons/solid/circle-info';
import styles from './ApplicationForm.module.scss';
const countryKeys = Object.keys(countries).sort((a, b) => a === 'US' ? -1 : b === 'US' ? 1 : 0);
function Demographics(t0) {
  const $ = _c(29);
  const {
    autoFocus: t1
  } = t0;
  const autoFocus = t1 === undefined ? true : t1;
  const formik = useFormikContext();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      date: true,
      datePattern: ["m", "d", "Y"]
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== autoFocus) {
    t3 = <FieldGroup label="Date of Birth"><Field autoFocus={autoFocus} name="dob" placeholder="MM/DD/YYYY" formatOptions={t2} /></FieldGroup>;
    $[1] = autoFocus;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FieldGroup label="Gender"><Field as="select" name="gender"><option value="male">Male</option><option value="female">Female</option><option value="no-binary">Non-binary</option><option value="other">Other</option><option value="preferNotToSay">Prefer not to say</option></Field></FieldGroup>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FieldGroup label="Pronouns"><Field as="select" name="pronouns"><option value="preferNotToSay">Prefer not to say</option><option value="he/him">He/Him</option><option value="she/her">She/Her</option><option value="they/them">They/Them</option><option value="other">Other</option></Field></FieldGroup>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FieldChoiceGroup legend="Are you a U.S. Citizen?" name="usCitizen" columns={2}><Field type="radio" name="usCitizen" value="yes" label="Yes" /><Field type="radio" name="usCitizen" value="no" label="No" /></FieldChoiceGroup>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== formik.values.usCitizen) {
    t7 = formik.values.usCitizen === "no" && <><FieldGroup label="Which country are you a citizen of?"><Field as="select" name="countryOfCitizenship">{countryKeys.filter(_temp).map(_temp2)}</Field></FieldGroup><FieldGroup label={<>Alien Registration Number (for US Green Card holders only, also called an “A-number,” “A#,” or “USCIS number”){" "}<FieldHint>(if applicable)</FieldHint></>}><Field name="alienRegistrationNumber" /></FieldGroup></>;
    $[6] = formik.values.usCitizen;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== formik.errors || $[9] !== formik.touched || $[10] !== formik.values.usCitizen) {
    t8 = !!formik.values.usCitizen && <FieldGroup label={<>Social Security Number{formik.values.usCitizen === "no" && <FieldHint> (if applicable)</FieldHint>}<Tooltip delay={0} placement="right" distance={5} content="Used for financial aid purposes"><span className={styles["tooltip-trigger"]}><SolidCircleInfoIcon /></span></Tooltip></>} error={!!formik.touched.ssn && !!formik.errors.ssn ? "Must be 9 digits." : undefined}><Field name="ssn" placeholder="***-**-****" formatOptions={{
        blocks: [3, 2, 4],
        delimiter: "-",
        numericOnly: true
      }} /></FieldGroup>;
    $[8] = formik.errors;
    $[9] = formik.touched;
    $[10] = formik.values.usCitizen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FieldGroup label="Did either of your parents attend or complete college?"><Field as="select" name="familyFirstCollege"><option value="neither">Neither parent attended college</option><option value="attended">One or both parents attended college, but neither parent completed college</option><option value="graduated">One or both parents completed college</option><option value="unknown">I don't know</option></Field></FieldGroup>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FieldChoiceGroup legend="Have you ever enrolled in a college or university before?" name="pastCollegeEnrollment" columns={2}><Field type="radio" name="pastCollegeEnrollment" value="yes" label="Yes" /><Field type="radio" name="pastCollegeEnrollment" value="no" label="No" /></FieldChoiceGroup>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== formik.values.pastCollegeEnrollment) {
    t11 = formik.values.pastCollegeEnrollment === "yes" && <><FieldGroup label="What was the name of the institution?"><Field name="pastCollegeName" /></FieldGroup><FieldSet legend="When were you there?"><FieldRow><FieldGroup name="pastCollegeFrom"><Field name="pastCollegeFrom" placeholder="From (MM/YYYY)" formatOptions={{
              date: true,
              datePattern: ["m", "Y"]
            }} /></FieldGroup><FieldGroup name="pastCollegeTo"><Field name="pastCollegeTo" placeholder="To (MM/YYYY)" formatOptions={{
              date: true,
              datePattern: ["m", "Y"]
            }} /></FieldGroup></FieldRow></FieldSet></>;
    $[14] = formik.values.pastCollegeEnrollment;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FieldGroup label="What is your status with the US military?"><Field as="select" name="armedForcesStatus"><option value="notApplicable">N/A</option><option value="activeDuty">Active Duty</option><option value="veteran">Veteran</option><option value="spouse">Spouse of Active Duty or Veteran</option><option value="dependent">Dependent of Active Duty or Veteran</option></Field></FieldGroup>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== formik.values.armedForcesStatus) {
    t13 = formik.values.armedForcesStatus !== "notApplicable" && <FieldSet legend="Dates of Service"><FieldRow><FieldGroup name="armedForcesFrom"><Field name="armedForcesFrom" placeholder="From (MM/YYYY)" formatOptions={{
            date: true,
            datePattern: ["m", "Y"]
          }} /></FieldGroup><FieldGroup name="armedForcesTo"><Field name="armedForcesTo" placeholder="To (MM/YYYY)" formatOptions={{
            date: true,
            datePattern: ["m", "Y"]
          }} /></FieldGroup></FieldRow></FieldSet>;
    $[17] = formik.values.armedForcesStatus;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FieldChoiceGroup legend="Are you Hispanic or Latino?" name="hispanicOrLatino" columns={2}><Field type="radio" name="hispanicOrLatino" value="yes" label="Yes" /><Field type="radio" name="hispanicOrLatino" value="no" label="No" /></FieldChoiceGroup>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FieldGroup label="What is your race?"><Field as="select" name="race"><option value="black">Black or African American</option><option value="americanIndian">American Indian or Alaska Native</option><option value="nativeHawaiian">Native Hawaiian or Other Pacific Islander</option><option value="mixed">Mixed-race</option><option value="asian">Asian</option><option value="white">White</option></Field></FieldGroup>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FieldChoiceGroup legend="Do you have a working laptop/computer?" name="computerAccess" columns={2}><Field type="radio" name="computerAccess" value="yes" label="Yes" /><Field type="radio" name="computerAccess" value="no" label="No" /></FieldChoiceGroup>;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FieldChoiceGroup legend="Do you have reliable Wi-Fi/internet connection?" name="internetAccess" columns={2}><Field type="radio" name="internetAccess" value="yes" label="Yes" /><Field type="radio" name="internetAccess" value="no" label="No" /></FieldChoiceGroup>;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t3 || $[26] !== t7 || $[27] !== t8) {
    t18 = <>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t3;
    $[26] = t7;
    $[27] = t8;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  return t18;
}
function _temp2(k_0) {
  return <option key={k_0} value={k_0}>{countries[k_0]}</option>;
}
function _temp(k) {
  return k !== "US";
}
export default Demographics;